export default "__VITE_ASSET__Dz_KBgSX__"